// Vendor
import '../../vendor/vendor'

// Components
import '../../components/components'
import * as bootstrap from 'bootstrap'
import * as FilePond from 'filepond'
import FilePondPluginImagePreview from 'filepond-plugin-image-preview'
import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation'
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size'
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type'
import enquire from 'enquire.js'

// Anchor links

let anchors = document.querySelectorAll('a[href^="#"]')

if (anchors) {
	anchors.forEach(anchor => {
		anchor.addEventListener('click', function (e) {
			e.preventDefault()

			document.querySelector(this.getAttribute('href')).scrollIntoView({
				behavior: 'smooth'
			})
		})
	})
}

// Send mail

document.addEventListener('DOMContentLoaded', () => {
	const $btnModal = document.querySelector('.modal-done__button')

	if ($btnModal) {
		$btnModal.addEventListener('click', event => {
			event.preventDefault()
			scrollTo(0, 200)
		})
	}
})

// Swiper

document.addEventListener('DOMContentLoaded', () => {
	const swiper = new Swiper('.swiper', {
		pagination: {
			el: '.swiper-pagination',
			clickable: true
		},
		navigation: {
			nextEl: '.swiper-custom-button-next',
			prevEl: '.swiper-custom-button-prev'
		},
		loop: true,
		mousewheel: true,
		keyboard: true,
		spaceBetween: 30,
		observer: true,
		observeParents: true,
		parallax: true,
		grabCursor: true,
		effect: 'creative',
		creativeEffect: {
			prev: {
				shadow: true,
				translate: [0, 0, -400]
			},
			next: {
				translate: ['100%', 0, 0]
			}
		}
	})
})

document.addEventListener('DOMContentLoaded', () => {
	const allSwipers = document.querySelectorAll('.swiper.gallery')
	allSwipers.forEach(swiperElement => {
		const swiperNumber = swiperElement.getAttribute('data-swiper')
		const swiperPagination = document.querySelector(`.swiper-pagination[data-swiper="${swiperNumber}"]`)
		const swiper = new Swiper(swiperElement, {
			pagination: {
				el: swiperPagination,
				clickable: true,
				renderBullet(index, className) {
					return `<span class="${className}" data-swiper="${swiperNumber}" data-slide="${index}"></span>`
				}
			},
			navigation: {
				nextEl: swiperElement.querySelector('.swiper-custom-button-next'),
				prevEl: swiperElement.querySelector('.swiper-custom-button-prev')
			},
			loop: true,
			mousewheel: true,
			keyboard: true,
			spaceBetween: 30,
			observer: true,
			observeParents: true,
			parallax: true,
			grabCursor: false,
			effect: 'creative',
			creativeEffect: {
				prev: {
					shadow: true,
					translate: [0, 0, -400]
				},
				next: {
					translate: ['100%', 0, 0]
				}
			}
		})
		// Добавляем дополнительный атрибут данных к точкам пагинации
		const paginationBullets = swiperPagination.querySelectorAll('.swiper-pagination-bullet')
		paginationBullets.forEach((bullet, index) => {
			bullet.setAttribute('data-swiper', index)
		})
		swiper.on('slideChange', () => {
			swiper.pagination.render()
			swiper.pagination.update()
		})
	})
})

// Auto-open accordion on docs page

$(document).ready(() => {
	// Ожидаем событие клика по ссылке
	document.querySelectorAll('.custom-link').forEach((link) => {
		link.addEventListener('click', (event) => {
			// Предотвращаем переход по ссылке
			event.preventDefault()

			// Получаем значение дата-атрибута для определения вкладки
			const tabId = link.getAttribute('data-tab')

			localStorage.setItem('storeTab', tabId)

			// Переходим на страницу, указанную в href ссылки
			const pageURL = link.getAttribute('href')
			if (pageURL) {
				window.location.href = pageURL
			}
		})
	})

	let storeTabValue = localStorage.getItem('storeTab')

	if (storeTabValue && window.location.pathname === '/docs') {
		// Активируем вкладку с соответствующим дата-атрибутом
		let tab = document.querySelector(`[data-bs-toggle="pill"][data-tab="${storeTabValue}"]`)
		tab.click()
	}
	if (storeTabValue && window.location.pathname === '/docs' && window.innerWidth <= 991) {
		// Активируем вкладку с соответствующим дата-атрибутом
		let tab = document.querySelector(`[data-bs-toggle="collapse"][data-tab="${storeTabValue}"]`)
		tab.click()
	}
})

// Filepond in callback resident

FilePond.registerPlugin(
	FilePondPluginImagePreview,
	FilePondPluginImageExifOrientation,
	FilePondPluginFileValidateSize,
	FilePondPluginFileValidateType
	/* FilePondPluginFileEncode*/
)

const pond = FilePond.create(document.querySelector('.file-upload-multiple'), {
	allowFileTypeValidation: true,
	acceptedFileTypes: [
		'image/png',
		'image/jpg',
		'image/jpeg',
		'image/heic',
		'image/heif',
		'application/pdf'
	]
})

FilePond.setOptions({
	labelIdle: '<span class="filepond--title">Перетащите изображение или PDF сюда, или нажмите на кнопку</span><span class="filepond--subtitle"> Поддерживаемые форматы: jpg, jpeg, png, pdf</span><span class="filepond--subtitle">Максимальный размер файла 20 MB</span> <span class="filepond--label-action"> Загрузить файл </span>',
	labelInvalidField: 'Поле содержит недопустимые файлы',
	labelFileWaitingForSize: 'Укажите размер',
	labelFileSizeNotAvailable: 'Размер не поддерживается',
	labelFileLoading: 'Ожидание',
	labelFileLoadError: 'Ошибка при ожидании',
	labelFileProcessing: 'Загрузка',
	labelFileProcessingComplete: 'Загрузка завершена',
	labelFileProcessingAborted: 'Загрузка отменена',
	labelFileProcessingError: 'Ошибка при загрузке',
	labelFileProcessingRevertError: 'Ошибка при возврате',
	labelFileRemoveError: 'Ошибка при удалении',
	labelTapToCancel: 'нажмите для отмены',
	labelTapToRetry: 'нажмите, чтобы повторить попытку',
	labelTapToUndo: 'нажмите для отмены последнего действия',
	labelButtonRemoveItem: 'Удалить',
	labelButtonAbortItemLoad: 'Прекращено',
	labelButtonRetryItemLoad: 'Повторите попытку',
	labelButtonAbortItemProcessing: 'Отмена',
	labelButtonUndoItemProcessing: 'Отмена последнего действия',
	labelButtonRetryItemProcessing: 'Повторите попытку',
	labelButtonProcessItem: 'Загрузка',
	labelMaxFileSizeExceeded: 'Файл слишком большой',
	labelMaxFileSize: 'Максимальный размер файла: {filesize}',
	labelMaxTotalFileSizeExceeded: 'Превышен максимальный размер',
	labelMaxTotalFileSize: 'Максимальный размер файла: {filesize}',
	labelFileTypeNotAllowed: 'Файл неверного типа',
	fileValidateTypeLabelExpectedTypes: 'Ожидается {allButLastType} или {lastType}',
	imageValidateSizeLabelFormatError: 'Тип изображения не поддерживается',
	imageValidateSizeLabelImageSizeTooSmall: 'Изображение слишком маленькое',
	imageValidateSizeLabelImageSizeTooBig: 'Изображение слишком большое',
	imageValidateSizeLabelExpectedMinSize: 'Минимальный размер: {minWidth} × {minHeight}',
	imageValidateSizeLabelExpectedMaxSize: 'Максимальный размер: {maxWidth} × {maxHeight}',
	imageValidateSizeLabelImageResolutionTooLow: 'Разрешение слишком низкое',
	imageValidateSizeLabelImageResolutionTooHigh: 'Разрешение слишком высокое',
	imageValidateSizeLabelExpectedMinResolution: 'Минимальное разрешение: {minResolution}',
	imageValidateSizeLabelExpectedMaxResolution: 'Максимальное разрешение: {maxResolution}'
})

// Callback resident form

document.addEventListener('DOMContentLoaded', () => {
	const ticketResidentModal = new bootstrap.Modal('#callback--resident')
	const ticketResidentModalDone = new bootstrap.Modal('#callbackFormResidentModalDone')
	const ticketResidentForm = $('#callback--resident__form')
	const inputName = document.querySelector('#callback--resident input#name')
	const inputNameCallback = document.querySelector('#callback__form input#callback__form--name')
	const inputPhoneCallback = document.querySelector('#callback__form input#callback__form--phone')
	const inputEmailCallback = document.querySelector('#callback__form input#callback__form--email')
	const inputAddressCallback = document.querySelector('#callback__form input#callback__form--address')
	const inputFlatsCallback = document.querySelector('#callback__form input#callback__form--flats')
	const submitCallback = document.querySelector('#callback__form button#callback__form--submit')
	const inputPhone = document.querySelector('#callback--resident input#phone')
	const inputEmail = document.querySelector('#callback--resident input#email')
	const inputAddress = document.querySelector('#callback--resident input#address')
	const inputAddressHouse = document.querySelector('#callback--resident input#address-house')
	const inputAddressFlat = document.querySelector('#callback--resident input#address-flat')
	const nextBtn = document.querySelector('#callback--resident .callback--resident__form--next')
	const prevBtn = document.querySelector('#callback--resident .callback--resident__form--prev')
	const formSubTitle = document.querySelector('#callback--resident .callback--resident__form--subtitle')

	function stepsCallbackResidentForm() {
		let triggerName = false
		let triggerPhone = false
		let triggerEmail = false
		let triggerAddress = false
		let triggerAddressHouse = false
		let triggerAddressFlat = false

		if (inputName.value.trim() !== '') {
			triggerName = true
		}
		if (inputPhone.value.trim() !== '') {
			triggerPhone = true
		}
		if (inputEmail.value.trim() !== '') {
			triggerEmail = true
		}
		if (inputAddress.value.trim() !== '') {
			triggerAddress = true
		}
		if (inputAddressHouse.value.trim() !== '') {
			triggerAddressHouse = true
		}
		if (inputAddressFlat.value.trim() !== '') {
			triggerAddressFlat = true
		}

		// eslint-disable-next-line max-len
		if (triggerName && triggerPhone && triggerEmail && triggerAddress && triggerAddressHouse && triggerAddressFlat) {
			nextBtn.removeAttribute('disabled')
		} else {
			nextBtn.setAttribute('disabled', '')
		}
	}

	inputName.addEventListener('focusout', stepsCallbackResidentForm)
	inputName.addEventListener('input', stepsCallbackResidentForm)

	inputPhone.addEventListener('focusout', stepsCallbackResidentForm)
	inputPhone.addEventListener('input', stepsCallbackResidentForm)

	inputEmail.addEventListener('focusout', stepsCallbackResidentForm)
	inputEmail.addEventListener('input', stepsCallbackResidentForm)

	inputAddress.addEventListener('focusout', stepsCallbackResidentForm)
	inputAddress.addEventListener('input', stepsCallbackResidentForm)

	inputAddressHouse.addEventListener('focusout', stepsCallbackResidentForm)
	inputAddressHouse.addEventListener('input', stepsCallbackResidentForm)

	inputAddressFlat.addEventListener('focusout', stepsCallbackResidentForm)
	inputAddressFlat.addEventListener('input', stepsCallbackResidentForm)

	function validationCallbackResidentForm() {
		if (!inputName || !inputPhone || !inputEmail || !inputAddress) {
			// eslint-disable-next-line no-console
			console.log('Валидация формы заявки не установлена')

			return
		}

		// ? Добавляем обработчик события ввода ФИО
		inputName.addEventListener('input', (event) => {
			// ? Получаем введенный текст из поля ввода
			let inputValue = event.target.value

			// Проверяем, содержит ли введенный текст символы, не являющиеся кириллицей, пробелом или тире
			if (/[^-\u0400-\u04FF\s]/.test(inputValue) || /^[-\s]/.test(inputValue)) {
				// eslint-disable-next-line max-len
				// Если найдены символы, не являющиеся кириллицей или пробелом/тире в начале строки, добавляем класс input-warning
				event.target.classList.add('input-warning')

				// Удаляем символы, не являющиеся кириллицей или пробелом/тире в начале строки
				let filteredValue = inputValue.replace(/^[ -]+/, '').replace(/[^\u0400-\u04FF\s]/g, '')

				// Обновляем значение поля ввода
				event.target.value = filteredValue

				// Устанавливаем таймер на 1.5 секунды для удаления класса input-warning
				setTimeout(() => {
					event.target.classList.remove('input-warning')
				}, 1000)
			}
		})

		inputAddress.addEventListener('input', (event) => {
			// Получаем введенный текст из поля ввода
			let inputValue = event.target.value

			// Проверяем, содержит ли введенный текст символы, не соответствующие правилам
			if (/[^0-9\u0400-\u04FF\s-.,]/.test(inputValue) || /^\s/.test(inputValue)) {
				// Если найдены символы, не соответствующие правилам, добавляем класс input-warning
				event.target.classList.add('input-warning')

				// Удаляем символы, не соответствующие правилам и первый символ, если он тире или пробел
				let filteredValue = inputValue.replace(/^[ -]+/, '').replace(/[^\u0400-\u04FF\s0-9-., ]/g, '')

				// Обновляем значение поля ввода
				event.target.value = filteredValue

				// Устанавливаем таймер на 1.5 секунды для удаления класса input-warning
				setTimeout(() => {
					event.target.classList.remove('input-warning')
				}, 1500)
			}
		})

		console.log('Валидация формы заявки установлена')
	}

	validationCallbackResidentForm()

	function stepsCallbackForm() {
		let triggerName = false
		let triggerPhone = false
		let triggerEmail = false
		let triggerAddress = false
		let triggerFlats = false

		if (inputNameCallback.value.trim() !== '') {
			triggerName = true
		}
		if (inputPhoneCallback.value.trim() !== '') {
			triggerPhone = true
		}
		if (inputEmailCallback.value.trim() !== '') {
			triggerEmail = true
		}
		if (inputAddressCallback.value.trim() !== '') {
			triggerAddress = true
		}
		if (inputFlatsCallback.value.trim() !== '') {
			triggerFlats = true
		}

		if (triggerName && triggerPhone && triggerEmail && triggerAddress && triggerFlats) {
			submitCallback.removeAttribute('disabled')

			return true
		}
		submitCallback.setAttribute('disabled', '')

		return false
	}

	inputNameCallback.addEventListener('focusout', stepsCallbackForm)
	inputNameCallback.addEventListener('input', stepsCallbackForm)

	inputPhoneCallback.addEventListener('focusout', stepsCallbackForm)
	inputPhoneCallback.addEventListener('input', stepsCallbackForm)

	inputEmailCallback.addEventListener('focusout', stepsCallbackForm)
	inputEmailCallback.addEventListener('input', stepsCallbackForm)

	inputAddressCallback.addEventListener('focusout', stepsCallbackForm)
	inputAddressCallback.addEventListener('input', stepsCallbackForm)

	inputFlatsCallback.addEventListener('focusout', stepsCallbackForm)
	inputFlatsCallback.addEventListener('input', stepsCallbackForm)

	$(document).ready(() => {
		$('#callback__form').submit(function (e) {
			e.preventDefault()
			let validationResult = stepsCallbackForm()

			if (validationResult) {
				submitCallback.removeAttribute('disabled')

				let formData = $(this).serialize()

				$.ajax({
					type: 'POST',
					url: './mail.php',
					data: formData,
					success(response) {
						console.log('Email отправлен')
						$('#callbackFormModalDone').modal('show')
						$('#callback__form')[0].reset()
					},
					error(error) {
						console.error('Произошла ошибка при отправке Email')
						console.error(error.responseText)
					}
				})
			} else {
				submitCallback.setAttribute('disabled', '')
			}
		})
	})

	function validationCallbackForm() {
		if (!inputNameCallback) {
			// eslint-disable-next-line no-console
			console.log('Валидация формы заявки не установлена')

			return
		}

		// ? Добавляем обработчик события ввода ФИО
		inputNameCallback.addEventListener('input', (event) => {
			// ? Получаем введенный текст из поля ввода
			let inputValue = event.target.value

			// Проверяем, содержит ли введенный текст символы, не являющиеся кириллицей, пробелом или тире
			if (/[^-\u0400-\u04FF\s]/.test(inputValue) || /^[-\s]/.test(inputValue)) {
				// eslint-disable-next-line max-len
				// Если найдены символы, не являющиеся кириллицей или пробелом/тире в начале строки, добавляем класс input-warning
				event.target.classList.add('input-warning')

				// Удаляем символы, не являющиеся кириллицей или пробелом/тире в начале строки
				let filteredValue = inputValue.replace(/^[ -]+/, '').replace(/[^\u0400-\u04FF\s]/g, '')

				// Обновляем значение поля ввода
				event.target.value = filteredValue

				// Устанавливаем таймер на 1.5 секунды для удаления класса input-warning
				setTimeout(() => {
					event.target.classList.remove('input-warning')
				}, 1000)
			}
		})

		console.log('Валидация формы заявки установлена')
	}

	validationCallbackForm()

	let stepOne = true // Изначально находимся на первом шаге

	const formStepOne = document.querySelector('#callback--resident .callback--resident__form--step-1')
	const formStepTwo = document.querySelector('#callback--resident .callback--resident__form--step-2')

	function stepsToggle() {
		if (stepOne) {
			formStepOne.style.display = 'none'
			formStepTwo.style.display = 'flex'
			formSubTitle.textContent = 'Расскажите о проблеме'
			prevBtn.textContent = 'Назад'
			nextBtn.textContent = 'Отправить'
			stepOne = false // Переходим ко второму шагу
		} else {
			formStepOne.style.display = 'flex'
			formStepTwo.style.display = 'none'
			formSubTitle.textContent = 'Заполните контактную информацию'
			prevBtn.textContent = 'Отменить'
			nextBtn.textContent = 'Далее'
			stepOne = true // Возвращаемся на первый шаг
		}
	}

	function ticketFormSend() {
		const formData = new FormData(ticketResidentForm[0]) // Создаем объект FormData из формы
		console.log(formData)
		let pondFiles = pond.getFiles()
		console.log(pondFiles)

		// Добавляем файлы, выбранные через FilePond, в объект FormData
		pondFiles.forEach((file) => {
			formData.append('files[]', file.file, file.filename)
		})

		$.ajax({
			type: 'POST',
			url: './mail-resident.php',
			data: formData,
			processData: false,
			contentType: false,
			success(response) {
				// Действия при успешной отправке
				console.log('Email отправлен')
				// Можете добавить здесь уведомление для пользователя
				const closeButton = ticketResidentModal._element.querySelector('.btn-close') // Найти кнопку "Закрыть" в модальном окне
				if (closeButton) {
					closeButton.click() // Имитация клика на кнопку "Закрыть"
				}
				ticketResidentModalDone.show()
				stepOne = false
				stepsToggle()
				ticketResidentForm[0].reset()
				pond.removeFiles()
			},
			error(error) {
				// Действия при ошибке отправки
				console.error('Произошла ошибка при отправке Email')
				console.error(error.responseText)
				// Можете добавить здесь уведомление для пользователя
				const closeButton = ticketResidentModal._element.querySelector('.btn-close') // Найти кнопку "Закрыть" в модальном окне
				if (closeButton) {
					closeButton.click() // Имитация клика на кнопку "Закрыть"
				}
				ticketResidentModalDone.show()
			}
		})
	}

	nextBtn.addEventListener('click', (e) => {
		e.preventDefault() // Предотвращение отправки формы
		if (!stepOne) {
			console.log('send')
			ticketFormSend()
		} else {
			stepsToggle()
		}
	})

	ticketResidentForm.on('submit', (e) => {
		e.preventDefault() // Предотвращение отправки формы

		// Вызываем функцию отправки формы
		ticketFormSend()
	})

	prevBtn.addEventListener('click', (e) => {
		e.preventDefault() // Предотвращение отправки формы
		if (stepOne) {
			// Если на первом шаге, имитируем клик на кнопку "Закрыть" модального окна
			const closeButton = ticketResidentModal._element.querySelector('.btn-close') // Найти кнопку "Закрыть" в модальном окне
			if (closeButton) {
				closeButton.click() // Имитация клика на кнопку "Закрыть"
			}
		} else {
			// Если на втором шаге, вернуться на первый шаг
			stepsToggle()
		}
	})
})

// Получаем ссылки на элементы <select>
const firstSelect = document.getElementById('service')
const secondSelect = document.getElementById('type-service')

// Слушаем изменения в первом <select>
if (firstSelect && secondSelect) {
	firstSelect.addEventListener('change', () => {
		// Получаем выбранный в первом <select> элемент
		const selectedOption = firstSelect.options[firstSelect.selectedIndex]

		// Получаем значение атрибута data-service-id выбранного элемента
		const selectedServiceId = selectedOption.getAttribute('data-service-id')

		// Скрываем все элементы второго <select>
		for (const option of secondSelect.options) {
			option.style.display = 'none'
		}

		// Отображаем только те элементы второго <select>, которые имеют соответствующее значение data-type-service-id
		for (const option of secondSelect.options) {
			const typeServiceId = option.getAttribute('data-type-service-id')
			if (typeServiceId === selectedServiceId) {
				option.style.display = 'block'
			}
			secondSelect.removeAttribute('disabled')
		}
	})
	// Изначально скрываем все элементы второго <select>
	for (const option of secondSelect.options) {
		option.style.display = 'none'
	}
	secondSelect.setAttribute('disabled', '')
}

// Dadata

$('.callback--resident__form--input input#address').on('input', function (e) {
	// * Jq версия скрипта
	let inputParent = $(this)
	let parentFormGroupSearch = inputParent.closest('.callback--resident__form--input')
	let parentSearchAutocomplete = parentFormGroupSearch.find('.result-search-street')
	let blockSearchDadata = parentSearchAutocomplete.find('.autocomplete-result-list')

	let search = inputParent.val()
	let searchInput = this

	function hideAutocomplete() {
		blockSearchDadata.removeClass('active')
	}

	function showAutocomplete() {
		blockSearchDadata.addClass('active')
	}

	if (search.length > 2) {
		let url = 'https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/address'
		let token = '2bddf7a49a6452e3977c9e0d960808d60273b39e'
		let query = `г Воронеж ${search}`

		let options = {
			method: 'POST',
			mode: 'cors',
			headers: {
				'Content-Type': 'application/json',
				'Accept': 'application/json',
				'Authorization': `Token ${token}`
			},
			body: JSON.stringify({ query })
		}

		function addResultSearch(result) {
			let arrayResult = JSON.parse(result)
			let suggestion = arrayResult.suggestions
			let allSearchResult = ''

			suggestion.forEach((line) => {
				allSearchResult += `<li data-street="${line.value}">${line.value}</li>`
			})

			blockSearchDadata.empty()
			blockSearchDadata.append(allSearchResult)

			if (suggestion.length > 0) {
				showAutocomplete()
			} else {
				hideAutocomplete()
			}
		}

		if (e.key !== 'Enter' && e.key !== 'ArrowDown' && e.key !== 'ArrowUp') {
			fetch(url, options)
				.then(response => response.text())
				.then(result => addResultSearch(result))
				.catch(error => console.log('error', error))
		}
	} else {
		hideAutocomplete()
	}

	$(document).on('click', (event) => {
		let target = $(event.target)
		if (!target.closest(parentSearchAutocomplete).length && target[0] !== searchInput) {
			hideAutocomplete()
		} else if (target[0] === searchInput) {
			showAutocomplete()
		}
	})

	blockSearchDadata.on('click', 'li', function () {
		inputParent.val($(this).attr('data-street'))

		// Добавляем задержку перед снятием фокуса
		setTimeout(() => {
			hideAutocomplete()
			inputParent.blur()
		}, 100)
	})
})

// Dadata

$('form.callback__form input.callback__form--address#callback__form--address').on('input', function (e) {
	// * Jq версия скрипта
	let inputParent = $(this)
	let parentFormGroupSearch = inputParent.closest('form.callback__form')
	let parentSearchAutocomplete = parentFormGroupSearch.find('.result-search-street')
	let blockSearchDadata = parentSearchAutocomplete.find('.autocomplete-result-list')

	let search = inputParent.val()
	let searchInput = this

	function hideAutocomplete() {
		blockSearchDadata.removeClass('active')
	}

	function showAutocomplete() {
		blockSearchDadata.addClass('active')
	}

	if (search.length > 2) {
		let url = 'https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/address'
		let token = '2bddf7a49a6452e3977c9e0d960808d60273b39e'
		let query = `г Воронеж ${search}`

		let options = {
			method: 'POST',
			mode: 'cors',
			headers: {
				'Content-Type': 'application/json',
				'Accept': 'application/json',
				'Authorization': `Token ${token}`
			},
			body: JSON.stringify({ query })
		}

		function addResultSearch(result) {
			let arrayResult = JSON.parse(result)
			let suggestion = arrayResult.suggestions
			let allSearchResult = ''

			suggestion.forEach((line) => {
				allSearchResult += `<li data-street="${line.value}">${line.value}</li>`
			})

			blockSearchDadata.empty()
			blockSearchDadata.append(allSearchResult)

			if (suggestion.length > 0) {
				showAutocomplete()
			} else {
				hideAutocomplete()
			}
		}

		if (e.key !== 'Enter' && e.key !== 'ArrowDown' && e.key !== 'ArrowUp') {
			fetch(url, options)
				.then(response => response.text())
				.then(result => addResultSearch(result))
				.catch(error => console.log('error', error))
		}
	} else {
		hideAutocomplete()
	}

	$(document).on('click', (event) => {
		let target = $(event.target)
		if (!target.closest(parentSearchAutocomplete).length && target[0] !== searchInput) {
			hideAutocomplete()
		} else if (target[0] === searchInput) {
			showAutocomplete()
		}
	})

	blockSearchDadata.on('click', 'li', function () {
		inputParent.val($(this).attr('data-street'))

		// Добавляем задержку перед снятием фокуса
		setTimeout(() => {
			hideAutocomplete()
			inputParent.blur()
		}, 100)
	})
})

// Функция для обработки изменений в поле ввода
function handleInputChange(event) {
	const inputElement = event.target
	let value = parseInt(inputElement.value, 10)

	// Проверяем, является ли значение числом
	if (isNaN(value)) {
		value = 1
	} else if (value < 1) {
		// Если введенное значение меньше 1 или отрицательное, устанавливаем 1
		value = 1
	}

	// Обновляем значение поля
	inputElement.value = value
}

// Находим все поля ввода с типом "number"
const numberFields = document.querySelectorAll('input[type="number"]')

// Добавляем обработчик события input для каждого поля
numberFields.forEach((field) => {
	field.addEventListener('input', handleInputChange)
})

// Очищаем поле при клике на него и нажатии клавиши Backspace
numberFields.forEach((field) => {
	field.addEventListener('keydown', (event) => {
		if (event.key === 'Backspace') {
			field.value = ''
		}
	})
})

// accordion

const eventsLists = document.querySelectorAll('.events .events__items .events__item')
const eventsAllLists = document.querySelectorAll('.eventsAll .eventsAll__items .eventsAll__item')

function handleItemClick(item) {
	const moreButton = item.querySelector('.events__item--more') || item.querySelector('.eventsAll__item--more')
	const descElement = item.querySelector('.events__item--desc') || item.querySelector('.eventsAll__item--desc')
	const arrowTextElement = moreButton.querySelector('span')
	const arrowElement = moreButton.querySelector('svg')

	moreButton.addEventListener('click', () => {
		// eslint-disable-next-line no-use-before-define
		if (lastClickedItem && lastClickedItem !== item) {
			// eslint-disable-next-line no-use-before-define
			lastClickedItem.querySelector('.events__item--desc, .eventsAll__item--desc').classList.add('collapse-desc')
			// eslint-disable-next-line no-use-before-define
			lastClickedItem.querySelector('.events__item--more span, .eventsAll__item--more span').textContent = 'подробнее'
			// eslint-disable-next-line no-use-before-define
			lastClickedItem.querySelector('.events__item--more svg, .eventsAll__item--more svg').style.transform = 'rotate(0deg)'
		}

		descElement.classList.toggle('collapse-desc')
		arrowTextElement.textContent = arrowTextElement.textContent === 'скрыть' ? 'подробнее' : 'скрыть'
		arrowElement.style.transform = arrowElement.style.transform === 'rotate(0deg)' ? 'rotate(180deg)' : 'rotate(0deg)'

		// eslint-disable-next-line no-use-before-define
		lastClickedItem = item
	})
}

let lastClickedItem = null

eventsLists.forEach(handleItemClick)
eventsAllLists.forEach(handleItemClick)

enquire.register('screen and (min-width: 991.98px)', {
	// deferSetup: true,
	match() {
		// Получаем все элементы .mainmenu__item--parent
		const parentItems = document.querySelectorAll('.mainmenu__item--parent')

		// Обходим каждый элемент
		parentItems.forEach(parentItem => {
			// Получаем элемент ul.mainmenu__dropdown
			const dropdownMenu = parentItem.querySelector('ul.mainmenu__dropdown')
			let timeoutId

			// Добавляем обработчик события на вход и выход курсора мыши
			parentItem.addEventListener('mouseenter', () => {
				// Добавляем класс active
				dropdownMenu.classList.add('active')
				// Если устанавливен таймер для удаления класса active, отменяем его
				clearTimeout(timeoutId)
			})

			parentItem.addEventListener('mouseleave', () => {
				// Запускаем таймер для удаления класса active через 1.5 секунды
				timeoutId = setTimeout(() => {
					dropdownMenu.classList.remove('active')
				}, 1200)
			})

			// Добавляем обработчик события на вход и выход курсора мыши в подменю
			dropdownMenu.addEventListener('mouseenter', () => {
				// Если установлен таймер для удаления класса active, отменяем его
				clearTimeout(timeoutId)
			})

			dropdownMenu.addEventListener('mouseleave', () => {
				// Запускаем таймер для удаления класса active через 1.5 секунды
				timeoutId = setTimeout(() => {
					dropdownMenu.classList.remove('active')
				}, 1200)
			})
		})
	}
})
